export const handleChangeDataSettlementsPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_SETTLEMENTS', name, value
});